var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 1.6875C6.20508 1.6875 3.9375 3.84574 3.9375 6.50391C3.9375 9.5625 7.3125 14.4095 8.55176 16.0836C8.6032 16.1543 8.67062 16.2118 8.74852 16.2515C8.82642 16.2911 8.91259 16.3118 9 16.3118C9.08741 16.3118 9.17358 16.2911 9.25148 16.2515C9.32938 16.2118 9.3968 16.1543 9.44824 16.0836C10.6875 14.4102 14.0625 9.56496 14.0625 6.50391C14.0625 3.84574 11.7949 1.6875 9 1.6875Z",
    stroke: "#FFDB70",
    strokeWidth: 1.23047,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 8.4375C9.93198 8.4375 10.6875 7.68198 10.6875 6.75C10.6875 5.81802 9.93198 5.0625 9 5.0625C8.06802 5.0625 7.3125 5.81802 7.3125 6.75C7.3125 7.68198 8.06802 8.4375 9 8.4375Z",
    stroke: "#FFDB70",
    strokeWidth: 1.23047,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.474f0a2f0ad4a5640786c33d72298f46.svg";
export { ForwardRef as ReactComponent };